module.exports = "<div id=\"virtual_card\">\n    <div id=\"card_header\">\n        <div id=\"card_logo\"></div>\n    </div>\n    <div id=\"card_footer\">\n        <div id=\"card_user\" ng-if=\"auth.loggedIn()\">{{ellipsis(auth.email)}}</div>\n    </div>\n    <div id=\"slider\" class=\"{{state}}\"></div>\n</div>\n<div id=\"virtual_card_message\">{{message}}</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/card-loader/template.html
// module id = ./components/xo-ui-components/src/card-loader/template.html
// module chunks = 1